// Registr podporovaných zemí pro mapu. Drží výchozí pohled mapy (střed + zoom)
// při přepnutí země. Názvy se překládají přes i18n (klíč `country.<code>`).

export type CountryCode = "cz" | "at";

export interface Country {
  code: CountryCode;
  /** Střed mapy při přepnutí na tuto zemi. */
  center: { lat: number; lng: number };
  zoom: number;
}

/**
 * Země nabízené v pickeru. **Země sem patří, až když pro ni existuje seed
 * migrace** – jinak přepnutí přistane na prázdné mapě. Hlídá to
 * `test/countries.test.ts` proti obsahu `migrations/`.
 *
 * Rakousko bylo do 2026-08-18 přesně ten případ: nabízelo se od začátku
 * projektu, ale žádný AT import se nikdy nespustil. Data doplnila migrace
 * `0007_seed_at.sql` (6 146 WC), takže je zpátky.
 */
export const COUNTRIES: Country[] = [
  { code: "cz", center: { lat: 50.0875, lng: 14.4214 }, zoom: 13 }, // Praha
  { code: "at", center: { lat: 48.2082, lng: 16.3738 }, zoom: 13 }, // Wien
];

export const DEFAULT_COUNTRY: CountryCode = "cz";

const STORAGE_KEY = "khakham:country";

/** Země podle kódu; pro neznámý kód vrátí výchozí zemi. */
export function countryByCode(code: string | null | undefined): Country {
  return (
    COUNTRIES.find((c) => c.code === code) ??
    COUNTRIES.find((c) => c.code === DEFAULT_COUNTRY)!
  );
}

/** Uložená volba země → výchozí země. Bezpečné i bez localStorage. */
export function detectCountry(): CountryCode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (COUNTRIES.some((c) => c.code === stored)) return stored as CountryCode;
  } catch {
    /* localStorage nemusí být dostupný */
  }
  return DEFAULT_COUNTRY;
}

export function storeCountry(code: CountryCode): void {
  try {
    localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* localStorage nemusí být dostupný */
  }
}
